import React, { useEffect } from 'react'
import { MediaCategory, StoredMediaCategory } from '../../../../types/Media'
import { useTranslation } from 'react-i18next'
import DeleteCategoryModal from '../DeleteCategoryModal/DeleteCategoryModal'
import EditCategoryModal from '../EditCategoryModal/EditCategoryModal'
import Button from '../../../../components/Button'
import styles from './CategoryList.module.scss'
import cx from 'classnames'
import { useFetchData } from '../../../../hooks/useFetchData'
import CategoryListItem from '../CategoryListItem'
import Loader from '../../../../components/Loader'
import CreateCategoryModal from '../CreateCategoryModal'
import { ApiRoutes } from '../../../../services/ApiService'
import { closeModal, openModal } from '../../../../services/ModalService'

const CategoryList: React.FC = () => {
    const {
        data: categories,
        isLoading,
        fetch,
    } = useFetchData<StoredMediaCategory>(ApiRoutes.MEDIA_CATEGORIES_AND_COUNT)
    const { t } = useTranslation(['settings'])

    const openCreateModal = () => {
        const content: JSX.Element = (
            <div style={{ minWidth: '350px' }}>
                <CreateCategoryModal
                    categories={categories}
                    onNewCategory={() => {
                        fetch()
                        closeModal()
                    }}
                />
            </div>
        )
        openModal({
            heading: t('categories.create_modal.heading'),
            content: content,
        })
    }

    const openEditModal = (category: MediaCategory) => {
        const content: JSX.Element = (
            <EditCategoryModal
                category={category}
                onSubmit={() => fetch()}
                categories={categories}
            />
        )
        openModal({
            heading: t('categories.edit_modal.heading'),
            content: content,
        })
    }

    const openDeleteModal = (category: MediaCategory) => {
        const content: JSX.Element = (
            <DeleteCategoryModal category={category} onSubmit={() => fetch()} />
        )
        openModal({
            heading: t('categories.delete_modal.heading'),
            content: content,
        })
    }

    useEffect(() => {
        fetch()
    }, [fetch])

    return (
        <>
            <Button
                hierarchy={'secondary'}
                text={t('categories.add')}
                fn={() => openCreateModal()}
            />
            {!isLoading && (
                <div className={cx(styles['table-container'])}>
                    <table className={cx(styles['zr-table'])}>
                        <thead className={cx(styles['table-header'])}>
                            <tr>
                                <th>{t('categories.name')} </th>
                                <th>{t('categories.count')}</th>
                                <th>{t('categories.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <CategoryListItem
                                paddingLeft={0}
                                parent={null}
                                tree={categories}
                                openDeleteModal={openDeleteModal}
                                openEditModal={openEditModal}
                                fetchCategories={fetch}
                            />
                        </tbody>
                    </table>
                </div>
            )}
            {isLoading && (
                <div className={'zr-w-100 zr-d-flex zr-justify-center'}>
                    <Loader isLoading={isLoading} size={'m'} />
                </div>
            )}
        </>
    )
}

export default CategoryList
